import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';

const QUERY = gql`
  query {
    states {
      stateCode
      countryCode
      name
    }
  }
`;

const useStates = () => {
  const { data, loading, error } = useQuery(QUERY);

  return loading || error ? [] : data.states;
};

export default useStates;
